import { useEffect, useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { LogOut } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { getDiscoveryStats } from "@/lib/apiClient";

const LINKS = [
  { to: "/admin/cases", label: "Cases" },
  { to: "/admin/patterns", label: "Patterns" },
  { to: "/admin/discovery", label: "Discovery" },
  { to: "/admin/discovery/queue", label: "Queue" },
  { to: "/admin/sources", label: "Sources" },
  { to: "/admin/explorations", label: "Explorations" },
];

export default function AdminNav() {
  const { admin, logout } = useAuth();
  const navigate = useNavigate();
  const [waiting, setWaiting] = useState(0);

  useEffect(() => {
    getDiscoveryStats().then((s) => setWaiting(s?.counts?.awaiting_review || 0)).catch(() => {});
  }, []);

  return (
    <div className="border-b-2 border-ink bg-white sticky top-0 z-30">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex items-center justify-between h-14">
        <div className="flex items-center gap-6">
          <span className="font-display font-extrabold text-xl tracking-tighter">AI YAI YAI<span className="text-brorange">!</span></span>
          <nav className="flex items-center gap-5">
            {LINKS.map((l) => (
              <NavLink key={l.to} to={l.to} end={l.to === "/admin/discovery"} data-testid={`adminnav-${l.label.toLowerCase()}`}
                className={({ isActive }) => `nav-underline text-sm font-semibold inline-flex items-center gap-1.5 ${isActive ? "active" : "text-ink/70"}`}>
                {l.label}
                {l.label === "Queue" && waiting > 0 && (
                  <span data-testid="queue-waiting-badge" className="bg-brorange text-white text-[0.65rem] font-bold px-1.5 py-0.5 leading-none rounded-full">{waiting}</span>
                )}
              </NavLink>
            ))}
          </nav>
        </div>
        <div className="flex items-center gap-3">
          <span className="hidden sm:inline text-xs text-ink/50">{admin?.email}</span>
          <button onClick={() => { logout(); navigate("/admin"); }} data-testid="admin-logout-button" className="btn-tactile inline-flex items-center gap-1.5 border-2 border-ink px-3 h-9 text-sm font-semibold hover:bg-secondary">
            <LogOut size={14} /> Logout
          </button>
        </div>
      </div>
    </div>
  );
}
